/**
 * ACORDE — Hero: puntos sincronizados con el deslizamiento y avance automático opcional.
 * El deslizamiento es scroll nativo (scroll-snap); aquí solo se observa qué diapositiva está a la
 * vista y, si el hero lo pide, se pasa a la siguiente cada N segundos (se detiene al tocar o si el
 * sistema pide menos movimiento).
 */
class AcordeHero extends HTMLElement {
  connectedCallback() {
    this.pista = this.querySelector('[data-pista]');
    this.puntos = [...this.querySelectorAll('[data-indice]')];
    if (!this.pista) return;
    this.diapositivas = [...this.pista.children];
    this.indice = 0;

    this.observador = new IntersectionObserver(
      (entradas) => {
        for (const entrada of entradas) {
          if (entrada.isIntersecting) this.marcar(this.diapositivas.indexOf(entrada.target));
        }
      },
      { root: this.pista, threshold: 0.6 }
    );
    this.diapositivas.forEach((d) => this.observador.observe(d));

    for (const punto of this.puntos) {
      punto.addEventListener('click', () => this.ir(Number(punto.dataset.indice)));
    }

    const segundos = Number(this.dataset.autoplay || 0);
    const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (segundos > 0 && !menosMovimiento && this.diapositivas.length > 1) {
      this.iniciar(segundos * 1000);
      for (const evento of ['pointerdown', 'touchstart', 'focusin']) {
        this.pista.addEventListener(evento, () => this.detener(), { passive: true });
      }
      document.addEventListener('visibilitychange', () => (document.hidden ? this.detener() : this.iniciar(segundos * 1000)));
    }
  }

  disconnectedCallback() {
    this.detener();
    this.observador?.disconnect();
  }

  marcar(indice) {
    if (indice < 0) return;
    this.indice = indice;
    this.puntos.forEach((p, i) => p.classList.toggle('acorde-hero__punto--activo', i === indice));
  }

  ir(indice) {
    const destino = this.diapositivas[indice];
    if (!destino) return;
    this.pista.scrollTo({ left: destino.offsetLeft - this.pista.offsetLeft, behavior: 'smooth' });
  }

  iniciar(ms) {
    this.detener();
    this.temporizador = setInterval(() => this.ir((this.indice + 1) % this.diapositivas.length), ms);
  }

  detener() {
    if (this.temporizador) clearInterval(this.temporizador);
    this.temporizador = null;
  }
}

if (!customElements.get('acorde-hero')) {
  customElements.define('acorde-hero', AcordeHero);
}
